import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Button, Header, Icon, Loader, Message, Popup, Segment, Table} from 'semantic-ui-react';

import {
    createApplication,
    deleteApplication,
    getApplications,
    revertApplication,
    sendApplication
} from "../../actions/application";

class ApplicationList extends Component {

    componentDidMount() {
        if (!this.props.authenticated) {
            this.props.history.push("/logowanie")
        } else {
            this.props.dispatch(getApplications());
        }
    }

    componentDidUpdate() {
        if (!this.props.authenticated) {
            this.props.history.push("/logowanie")
        }
    }

    onClickRefresh(e) {
        this.props.dispatch(getApplications());
    }

    onClickCreate(e, application) {
        this.props.dispatch(createApplication(application));
    }

    onClickSend(e, application) {
        this.props.dispatch(sendApplication(application));
    }

    onClickEdit(e, application) {
        this.props.history.push("/zgloszenia/" + application.id)
    }

    onClickDelete(e, application) {
        this.props.dispatch(deleteApplication(application));
    }

    onClickRevert(e, application) {
        this.props.dispatch(revertApplication(application));
    }

    render() {
        return (
            <div style={{margin: "1rem 0"}}>
                {this.renderLoader()}
                {this.renderLoadingError()}
                {this.renderApplications()}
            </div>
        );
    }

    renderLoader() {
        return this.props.loadingApplications &&
            <Segment textAlign='center' padded='very'><Loader inline active content='Wczytywanie zgłoszeń'/></Segment>
    }

    renderLoadingError() {
        return !this.props.loadingApplications && this.props.loadingApplicationsFailed
            && <Message negative
                        icon='exclamation triangle'
                        header='Nie udało sie pobrać zgłoszeń'
                        content={this.props.loadingApplicationsError}/>
    }

    renderApplications() {
        return !this.props.loadingApplications && !this.props.loadingApplicationsFailed
            && [this.renderHeader(), this.renderBody()]
    }

    renderHeader() {
        return <Table key={1} attached="top">
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell colSpan={2}>
                        <Header>
                            <Icon name="trophy"/>
                            <Header.Content>Zawody</Header.Content>
                        </Header>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Header>
        </Table>
    }

    renderBody() {
        return <Table key={2} attached="bottom">
            <Table.Body>
                {this.props.applications.map((application, index) => <Table.Row key={index}>
                    <Table.Cell>
                        {application.contest.name}
                        <p style={{fontStyle: 'italic', color: 'grey'}}>
                            {typeof application.status === 'undefined' && 'Brak zgłoszenia'}
                            {application.status === 'DRAFT' && 'Zgłoszenie w przygotowaniu'}
                            {application.status === 'SENT' && 'Zgłoszenie wysłane'}
                            {application.status === 'REJECTED' && 'Zgłoszenie odrzucone'}
                            {application.status === 'APPROVED' && 'Zgłoszenie zaakceptowane'}
                        </p>
                    </Table.Cell>
                    <Table.Cell collapsing textAlign="right">
                        {application.contest.registrationOpen
                        && typeof application.status === 'undefined'
                        && <Popup trigger={<Button positive
                                                   icon="add"
                                                   loading={this.props.creatingApplication && this.props.contestId === application.contest.id}
                                                   disabled={this.props.creatingApplication
                                                   || this.props.sendingApplication
                                                   || this.props.deletingApplication
                                                   || this.props.revertingApplication}
                                                   onClick={(e) => {
                                                       this.onClickCreate(e, application)
                                                   }}/>}
                                  content="Utwórz zgłoszenie"
                                  position="bottom right"
                                  inverted/>}
                        {application.contest.registrationOpen
                        && application.status === "DRAFT"
                        && <Popup trigger={<Button positive
                                                   icon="send"
                                                   loading={this.props.sendingApplication && this.props.applicationId === application.id}
                                                   disabled={this.props.creatingApplication
                                                   || this.props.sendingApplication
                                                   || this.props.deletingApplication
                                                   || this.props.revertingApplication}
                                                   onClick={(e) => {
                                                       this.onClickSend(e, application)
                                                   }}/>}
                                  content="Wyślij zgłoszenie"
                                  position="bottom right"
                                  inverted/>}
                        {typeof application.status !== "undefined"
                        && <Popup trigger={<Button primary
                                                   icon={application.status === "DRAFT"
                                                   && application.contest.registrationOpen ? "edit" : "search"}
                                                   disabled={this.props.creatingApplication
                                                   || this.props.sendingApplication
                                                   || this.props.deletingApplication
                                                   || this.props.revertingApplication}
                                                   onClick={(e) => {
                                                       this.onClickEdit(e, application)
                                                   }}/>}
                                  content={application.status === "DRAFT"
                                  && application.contest.registrationOpen ? "Edytuj zgłoszenie" : "Pokaż zgłoszenie"}
                                  position="bottom right"
                                  inverted/>}
                        {(application.status === "SENT" || application.status === "APPROVED")
                        && <Popup trigger={<Button color="pink"
                                                   as="a"
                                                   href={"/zgloszenie/pdf/" + application.uuid}
                                                   download
                                                   icon="download"
                                                   disabled={this.props.creatingApplication
                                                   || this.props.sendingApplication
                                                   || this.props.deletingApplication
                                                   || this.props.revertingApplication}/>}
                                  content={"Pobierz zgłoszenie"}
                                  position="bottom right"
                                  inverted/>}
                        {application.contest.registrationOpen
                        && application.status === "DRAFT"
                        && <Popup trigger={<Button negative
                                                   icon='trash alternate'
                                                   loading={this.props.deletingApplication && this.props.contestId === application.contest.id}
                                                   disabled={this.props.creatingApplication
                                                   || this.props.sendingApplication
                                                   || this.props.deletingApplication
                                                   || this.props.revertingApplication}
                                                   onClick={(e) => {
                                                       this.onClickDelete(e, application)
                                                   }}/>}
                                  content="Usuń zgłoszenie"
                                  position="bottom right"
                                  inverted/>}
                        {application.contest.registrationOpen
                        && application.status === "SENT"
                        && <Popup trigger={<Button icon="undo"
                                                   color='orange'
                                                   loading={this.props.revertingApplication && this.props.applicationId === application.id}
                                                   disabled={this.props.creatingApplication
                                                   || this.props.sendingApplication
                                                   || this.props.deletingApplication
                                                   || this.props.revertingApplication}
                                                   onClick={(e) => {
                                                       this.onClickRevert(e, application)
                                                   }}/>}
                                  content="Wycofaj zgłoszenie"
                                  position="bottom right"
                                  inverted/>}
                    </Table.Cell>
                </Table.Row>)}
            </Table.Body>
        </Table>
    }
}

function mapStateToProps(state) {
    return {
        authenticated: state.session.authenticated,
        loadingApplications: state.application.loadingApplications,
        loadingApplicationsFailed: state.application.loadingApplicationsFailed,
        loadingApplicationsError: state.application.loadingApplicationsError,
        creatingApplication: state.application.creatingApplication,
        creatingApplicationFailed: state.application.creatingApplicationFailed,
        creatingApplicationError: state.application.creatingApplicationError,
        sendingApplication: state.application.sendingApplication,
        sendingApplicationFailed: state.application.sendingApplicationFailed,
        sendingApplicationError: state.application.sendingApplicationError,
        revertingApplication: state.application.revertingApplication,
        revertingApplicationFailed: state.application.revertingApplicationFailed,
        revertingApplicationError: state.application.revertingApplicationError,
        deletingApplication: state.application.deletingApplication,
        deletingApplicationFailed: state.application.deletingApplicationFailed,
        deletingApplicationError: state.application.deletingApplicationError,
        applications: state.application.applications,
        contestId: state.application.contestId,
        applicationId: state.application.applicationId
    }
}

export default connect(mapStateToProps)(ApplicationList)


// WEBPACK FOOTER //
// ./src/components/routes/ApplicationList.js